import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SmsFailedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sms_failed"}/>
}
